import { createContext, useContext } from 'react';
export const TextBlockContext = createContext(null);
export const useTextBlockContext = () => useContext(TextBlockContext);
